/* Falconclaw cables - volume deal nudge (2026-08-25, DEV THEME PREVIEW)
   Drives snippets/fc-cable-volume-deal.liquid on the 11 PTT cable pages.
   Adapted from assets/falconclaw-ptt-volume.js (rev 2): same widget, but the
   count is the WHOLE CABLE GROUP, because the Shopify Function's "Cable
   volume" rule sums quantity across all 11 cable products.

   Combine rule: TOTAL = cable-group units in /cart.js (any of the 11
   products, this one included) + units currently selected in the quantity
   box. That is "what the cart-level Function will see once you add this".

   Savings figures are computed from real prices only: the group's
   original_line_price cents in the cart plus this page's unit price for the
   selected units. Mixed cables have mixed prices, so the euro figure is the
   sum over the actual set, never a per-unit guess.

   Placement modes: on a CABLE page the widget counts cart + the qty box.
   With data-fc-cvol-mode="cart-only" (the PTT page's cable-finder placement,
   where the qty box belongs to the PTT, not a cable) it counts ONLY the cable
   units already in the cart and never adds the page's selection.

   The discount itself is a Shopify Function. This file only narrates it. */
(function () {
  'use strict';

  if (document.documentElement.dataset.fcCvolBooted === '1') return;
  document.documentElement.dataset.fcCvolBooted = '1';

  var SEL = '[data-fc-cvol]';
  var PERCENT = 10;        /* overwritten from the block's data attribute */
  var product = null;      /* cached /products/<handle>.js payload */
  var groupUnits = 0;      /* cable-group units already in the cart */
  var groupCents = 0;      /* their original (pre-discount) line total, cents */
  var productPending = false;
  var cartPending = false;
  var renderQueued = false;

  /* ---------- helpers ---------- */

  function root() {
    return document.querySelector(SEL);
  }

  function intAttr(el, name, fallback) {
    var v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }

  function groupIds(el) {
    try {
      var arr = JSON.parse(el.getAttribute('data-fc-cvol-group') || '[]');
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function groupDots(intPart) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function groupCommas(intPart) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Format cents with the store's own money format so the widget matches the
     price block above it (falconclaw.eu renders "EUR 1.234,56" style). */
  function money(cents) {
    var settings = window.themeVariables && window.themeVariables.settings;
    var format = (settings && settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    var value = cents / 100;
    var parts = value.toFixed(2).split('.');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (whole, key) {
      switch (key) {
        case 'amount_with_comma_separator':
          return groupDots(parts[0]) + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return groupDots(String(Math.round(value)));
        case 'amount_no_decimals':
          return groupCommas(String(Math.round(value)));
        default:
          return groupCommas(parts[0]) + '.' + parts[1];
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Euro figures get the accent colour, everything else stays plain text. */
  function withAmount(before, cents, after) {
    return escapeHtml(before) + '<b>' + escapeHtml(money(cents)) + '</b>' + escapeHtml(after);
  }

  /* ---------- reading the page ---------- */

  function quantityInput(el) {
    var scope = el.closest('.product-info') || document;
    return scope.querySelector('input.quantity-selector__input[name="quantity"]') ||
      document.querySelector('input.quantity-selector__input[name="quantity"]');
  }

  function selectedQuantity(el) {
    var input = quantityInput(el);
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    return isNaN(n) || n < 0 ? 1 : n;
  }

  function selectedVariantId(el) {
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    if (match) return match[1];
    var scope = el.closest('.product-info') || document;
    var input = scope.querySelector('[name="id"]') || document.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function unitPriceCents(el) {
    if (!product) return 0;
    var id = selectedVariantId(el);
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i].price;
    }
    return product.price;
  }

  /* ---------- data ---------- */

  function loadProduct(handle) {
    if (product || productPending || !handle) return;
    productPending = true;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        productPending = false;
        if (data) { product = data; render(); }
      })
      .catch(function () { productPending = false; });
  }

  function loadCart(ids) {
    if (cartPending) return;
    cartPending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        cartPending = false;
        if (!cart) return;
        var units = 0;
        var cents = 0;
        (cart.items || []).forEach(function (item) {
          if (ids.indexOf(String(item.product_id)) === -1) return;
          units += item.quantity;
          cents += typeof item.original_line_price === 'number'
            ? item.original_line_price
            : (item.price || 0) * item.quantity;
        });
        groupUnits = units;
        groupCents = cents;
        render();
      })
      .catch(function () { cartPending = false; });
  }

  /* ---------- copy ---------- */

  function messageHtml(needed, totalCents) {
    var saved = Math.round((totalCents * PERCENT) / 100);
    if (needed >= 3) {
      return escapeHtml(needed + ' more unlocks -' + PERCENT +
        '% on every cable. Future-proof your PTT for any radio.');
    }
    if (needed === 2) {
      return escapeHtml('2 more unlocks -' + PERCENT +
        '% on every cable. One downlead per radio, one PTT for all of them.');
    }
    if (needed === 1) {
      return withAmount('ONE more cable and you save at least ', saved, '.');
    }
    return withAmount('Cable deal unlocked. You are saving ', saved, '.');
  }

  /* ---------- render ---------- */

  function render() {
    var el = root();
    if (!el) return;

    var handle = el.getAttribute('data-fc-cvol-handle');
    var ids = groupIds(el);
    var threshold = intAttr(el, 'data-fc-cvol-threshold', 4);
    PERCENT = intAttr(el, 'data-fc-cvol-percent', 10);
    var cartOnly = el.getAttribute('data-fc-cvol-mode') === 'cart-only';

    var selected, total, totalCents;
    if (cartOnly) {
      /* No product payload needed: the page's product is not a cable. */
      if (!el.dataset.fcCvolCartLoaded) {
        el.dataset.fcCvolCartLoaded = '1';
        loadCart(ids);
      }
      selected = 0;
      total = groupUnits;
      totalCents = groupCents;
    } else {
      if (!product) { loadProduct(handle); loadCart(ids); return; }

      /* Out of stock (or gone): the widget says nothing at all. */
      if (!product.available) { el.hidden = true; return; }
      el.hidden = false;

      var unit = unitPriceCents(el);
      if (!unit) return;

      selected = selectedQuantity(el);
      total = groupUnits + selected;
      totalCents = groupCents + unit * selected;
    }
    var needed = threshold - total;

    var key = [total, groupUnits, selected, totalCents, threshold].join(':');
    if (el.dataset.fcCvolKey === key) return;
    el.dataset.fcCvolKey = key;

    el.style.setProperty('--fc-vol-p', String(Math.min(total / threshold, 1)));

    var msg = el.querySelector('[data-fc-cvol-msg]');
    if (msg) {
      msg.innerHTML = messageHtml(needed, totalCents);
      msg.classList.remove('is-changed');
      /* force the keyframe to restart on every state change */
      void msg.offsetWidth;
      msg.classList.add('is-changed');
    }

    var split = el.querySelector('[data-fc-cvol-split]');
    if (split) {
      if (groupUnits > 0) {
        split.textContent = cartOnly
          ? groupUnits + (groupUnits === 1 ? ' cable' : ' cables') + ' in your cart so far.'
          : groupUnits + (groupUnits === 1 ? ' cable' : ' cables') +
            ' already in cart, ' + selected + ' selected here.';
        split.hidden = false;
      } else {
        split.textContent = '';
        split.hidden = true;
      }
    }

    var bar = el.querySelector('[data-fc-cvol-bar]');
    if (bar) {
      bar.setAttribute('aria-valuemax', String(threshold));
      bar.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
    }
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    setTimeout(function () { renderQueued = false; render(); }, 0);
  }

  function refreshCart() {
    var el = root();
    if (el) loadCart(groupIds(el));
  }

  /* ---------- wiring (document level, capture phase: Impact re-renders the
     buy box on variant change and swaps our node out) ---------- */

  function isQuantityField(target) {
    return target && target.matches && target.matches('input.quantity-selector__input[name="quantity"]');
  }

  document.addEventListener('input', function (e) {
    if (isQuantityField(e.target)) queueRender();
  }, true);

  document.addEventListener('change', function (e) {
    if (isQuantityField(e.target) || (e.target && e.target.name === 'id')) queueRender();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.quantity-selector__button')) { queueRender(); return; }
    if (t.closest('[name="add"], button[type="submit"], [data-fc-add-to-cart]')) {
      setTimeout(refreshCart, 700);
      setTimeout(refreshCart, 1800);
    }
  }, true);

  document.addEventListener('cart:refresh', refreshCart);
  document.addEventListener('cart:change', refreshCart);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCart();
  });

  /* The header cart badge is the one signal every add path updates, whatever
     drawer or app did the adding. */
  function watchCartCount() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('cart-count').forEach(function (node) {
      if (node.dataset.fcCvolWatched === '1') return;
      node.dataset.fcCvolWatched = '1';
      new MutationObserver(refreshCart).observe(node, {
        childList: true, subtree: true, characterData: true
      });
    });
  }

  function watchBody() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        /* ignore our own writes, or we loop */
        if (t && t.closest && t.closest(SEL)) continue;
        watchCartCount();
        queueRender();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    watchCartCount();
    watchBody();
    render();
    refreshCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
